// New Menu Burger Menu

$(document).ready(function () {

  var Menu = {

    el: {
      ham: $('.burger_menu'),
      animate_burger: $('.burger_menu')
    }, 

    init: function () {
      Menu.bindUIactions();
    },

    bindUIactions: function () {
      Menu.el.ham
        .on(
          'click',
          function (event) {
            Menu.activateMenu(event);
            event.preventDefault(); 
          }
        );
    },

    activateMenu: function () {
      Menu.el.ham.toggleClass('menu_close');
      Menu.el.animate_burger.toggleClass('clicked');
      $('.mobile_menu').toggleClass('slide_open');
    }
  };

  Menu.init();


  $(".parent_link_items").click(function() {
    $(".parent_link_items").removeClass("parent_open");
    $(this).addClass("parent_open");
    $(".arrow").removeClass("open_arrow");
    $(this).find(".arrow").addClass("open_arrow");
    $(".dropdown_outer").removeClass("dropdown_active");
    $(".dropdown_outer").removeClass("fadeIn");
    $(this).find(".dropdown_outer").addClass("dropdown_active");
    $(this).find(".dropdown_outer").addClass("fadeIn");
  });

  $(".arrow").click(function() {
    $("parent_link_items").removeClass("parent_open");
    $(this).removeClass("open_arrow"); 
  });

  // Has Children hover set active class incase you want to use an triangle


  $("li.has_children").hover(
    function () {
      console.log("hovered");
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
      } else {
        $(this).addClass("active");
      }
    },
    function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
      } else {
        $(this).addClass("active");
      }
    } 
  );

// Scroll back to the top after opening menu

if ($('.burger_menu').length) {
    var scrollTrigger = 100, // px
        backToTop = function () {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > scrollTrigger) {
                $('.burger_menu').addClass('show');
            } else {
                $('.burger_menu').removeClass('show');
            }
        };
    backToTop();
    $(window).on('scroll', function () {
        backToTop();
    });
    $('.burger_menu').on('click', function (e) {
        e.preventDefault();
        $('html,body').animate({
            scrollTop: 0
        }, 100);
    });
}


});
